import React from "react";
import {COPYRIGHT_TEXT } from "../constants";
import { BRAND_COLOR, TEXT_COLOR_WHITE } from "../constants";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: BRAND_COLOR,
        color: TEXT_COLOR_WHITE,
        textAlign: "center",
        padding: "20px",
        marginTop: "50px",
      }}
      id="contact"
    >
      <p>{COPYRIGHT_TEXT}</p>
    </footer>
  );
};

export default Footer;
